import { Progress } from 'antd';
import API from 'API';
import { NotFound } from 'AppRoute';
import { useAuth } from 'AuthContext';
import FullMask from 'components/layout/FullMask';
import React, { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import toastr from 'toastr';
import { CloseOutlined } from '@ant-design/icons';
import MessageBox from 'components/general/MessageBox';

const START_MESSAGE = "Xin chào! Tôi là giảng viên AI. Để hỗ trợ bạn tốt nhất, hãy miêu tả hoặc đặt toàn bộ câu hỏi trong một tin nhắn duy nhất nhé! 🚀";

export default function ChatBot({ lesson_id=null, course_id=null, setClose }) {
    const [loading, setLoading] = useState(true);
    const [numberOfChats, setNumberOfChats] = useState(null);
    const [searchParams] = useSearchParams();
    const [lessonName, setLessonName] = useState("");
    const token = searchParams.get("token");
    const { user } = useAuth();
    useEffect(() => {
        if (!(token || (lesson_id && user) || (course_id && user))) return;
        API.post("get-chatbot-answer/", {
            token: token,
            lesson_id: lesson_id,
            course_id: course_id,
        })
            .then(res => {
                setLoading(false);
                setNumberOfChats(res.data.chats);
                setLessonName(res.data.lesson);
            })
            .catch(error => {
                console.log(error);
                if (error.response?.status === 400) {
                    toastr.error("Token không hợp lệ!");
                }
            })
    }, [token, lesson_id, course_id, user])

    const sendMessage = useCallback(async (message, setMessage, chats)=>{
        try {
            const response = await API.post("get-chatbot-answer/", {
                token: token,
                question: message,
                lesson_id: lesson_id,
                course_id: course_id,
                last_question: chats.length > 1 ? {
                    "human": chats[chats.length - 2].message,
                    "AI": chats[chats.length - 1].message,
                } : null,
            })
            setNumberOfChats(response.data.chats);
            return response.data.answer;
        } catch (error) {
            if (error?.status === 400) {
                if (error?.response?.data?.error === "Lesson doesn't have video") {
                    toastr.error("Hiện bài học này chưa có nội dung!");
                    return;
                }
                if (error?.response?.data?.error === "Course doesn't have video") {
                    toastr.error("Hiện môn học này chưa có nội dung!");
                    return;
                }
            }
            return null;
        }
    },[token, lesson_id, course_id])

    if (!(token || (lesson_id && user) || (course_id && user))) {
        return <NotFound />
    }
    return loading ? <FullMask /> : <>
        {token ? <h4>{lessonName}</h4> : null}
        <div style={{
            border: "1px solid rgb(211, 211, 211)",
            borderRadius: 5,
        }}>
            <div style={{
                top: 0, left: 0, width: "100%",
                borderBottom: "1px solid rgb(218, 218, 218)",
                backgroundColor: "rgb(255, 255, 255)",
                color: "white !important",
                borderRadius: "5px 5px 0px 0px"
            }}>
                <Progress
                    style={{
                        display: "inline-block",
                        width: setClose ? "calc(100% - 19px)" : "100%",
                        paddingLeft: 5, paddingRight: 5,
                    }}
                    strokeColor="rgb(96, 211, 240)"
                    percent={(numberOfChats.max_chats - numberOfChats.number_chats) / numberOfChats.max_chats * 100}
                    status='normal'
                    format={() => `${numberOfChats.max_chats - numberOfChats.number_chats}/${numberOfChats.max_chats}`}
                />
                {setClose && <div style={{
                    display: "inline-block",
                    borderLeft: "1px solid rgb(172, 172, 172)",
                    width: 18, height: 22, textAlign: "center",
                    cursor: "pointer"
                }} onClick={setClose}>
                    <CloseOutlined />
                </div>}
            </div>
            <MessageBox sendMessage={sendMessage} defaultChat={[{
                message: START_MESSAGE
            }]}/>
        </div>
    </>
}
